import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgpMenu } from 'ng-primitives/menu';

/**
 * `<sui-menu>` — the action-menu panel. Lives inside the trigger's
 * `<ng-template>`; ng-primitives portals it into the configured container and
 * positions it with floating-ui. Hosts `NgpMenu` (gives `role=menu`, roving
 * focus, focus-trap, and item-click-closes for free) and adds the panel chrome
 * (surface-raised + radius + shadow). Items are projected (`<button
 * sui-menu-item>` / `<sui-menu-separator>` / `<sui-menu-header>`).
 *
 * The host carries `data-overlay` (from `NgpMenu`) and gets inline `left/top`
 * from the engine, so `:host` is `position: fixed` and stays invisible until
 * `[data-enter]` — see the SCSS.
 */
@Component({
  selector: 'sui-menu',
  standalone: true,
  hostDirectives: [NgpMenu],
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sui-menu.component.scss',
})
export class SuiMenuComponent {}
